<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li>
      <a>{{ company_name }}:</a>
    </li>
    <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ul>
  <div class="right">
    <span>{{ today }}</span>
  </div>

  <div class="tag_powered_by">
    <span>Powered by: <b>Enertics</b></span>
  </div>
</div>
<div class="Content_outer">
  <div
    style="display: flex; align-items: center; justify-content: space-between"
  >
    <h3 style="margin: 10px">All Parameters</h3>
    <div style="margin: 10px 10px 0px 0px">
      <button
        style="border: 1px solid black"
        (click)="downloadParametersValue()"
      >
        <span
          *ngIf="downloading == false; else downloadingLoader"
          class="sprite_icon download_grey"
          [ngClass]="{
            download_blue: downloadChartDataOn
          }"
        ></span>
        <ng-template #downloadingLoader>
          <div class="spinner-container charts-loader">
            <div
              style="
                width: 1.3rem !important;
                height: 1.3rem !important;
                color: blue !important;
              "
              class="spinner-border"
              role="status"
            ></div>
          </div>
        </ng-template>
      </button>

      <button
        style="border: 1px solid black"
        (click)="openEboilerAllThresholdSetting('ALL')"
        class="settings-icon"
      >
        <img
          style="width: 20px; height: 20px; cursor: pointer"
          src="./assets/settings.png"
        />
      </button>
    </div>
  </div>
  <div class="no_device" *ngIf="showEmptyError !== ''">
    <p style="color: #838383; padding: 90px">{{ showEmptyError }}</p>
  </div>
  <div
    class="grid-container eboiler_additional_paramteres"
    style="margin-top: 11px"
  >
    <button
      class="grid-item for_margin"
      *ngFor="let parameter of parametersList"
      style="cursor: pointer"
      [disabled]="chartloader"
      [style.background]="parameter.loader ? 'white' : parameter.color"
      (click)="getChartParameters(parameter.key)"
    >
      <span class="heading" *ngIf="!parameter.loader">{{
        parameter.name
      }}</span>
      <span *ngIf="!parameter.loader; else spinner">{{ parameter.value }}</span>
      <ng-template #spinner>
        <div class="spinner-container charts-loader">
          <div
            style="
              width: 2.3rem !important;
              height: 2.3rem !important;
              color: blue !important;
            "
            class="spinner-border"
            role="status"
          ></div>
        </div>
      </ng-template>
    </button>
  </div>
  <div
    class="spinner-container"
    *ngIf="loader"
    style="
      width: 100vw;
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
    "
  >
    <!-- <div class="spinner-border text-primary" role="status"></div> -->
  </div>
</div>
